import classnames from 'classnames';

export const themes = {
  default: ({ color, isExpand, isLarge }) => ({
    thRoot: `bg-${color} relative text-center text-white decorator-trident-bg-white`,
    thRootStyle: isLarge ? { paddingBottom: '63.15789%' } : null,
    thLink: 'block md:absolute overflow-hidden md:inset-0 no-underline text-white',
    thBody: 'flex flex-col items-center justify-center md:absolute md:inset-0  p-4',
    thtitle:
      'Tile-title font-brand font-normal leading-one m-0 text-2xl sm:text-4xl transition-all',
    thCatchline: classnames('font-sans leading-tight mt-3 mb-0 text-md transition-all', {
      'h-auto': !isExpand && isLarge,
      'h-0 opacity-0': isExpand && isLarge,
    }),
    thText: classnames(
      'hidden md:block leading-normal mb-0 px-2 overflow-hidden text-base transition-all w-full',
      {
        'h-0 opacity-0  mt-3': !isExpand && isLarge,
        'h-auto mt-0 opacity-100': isExpand && isLarge,
      },
    ),
  }),
};
